import { IEventHubDTO } from '../../../../api/event-hubs.dao';
import { observer } from 'mobx-react';
import Text from '../../../global/text/text';
import React from 'react';
import { Container } from 'typescript-ioc';
import { DateTimeFormatter } from '../../../../infrastructure/implementations/date-formatter';
import { Link } from '../../../../infrastructure/components/router-extensions';
import { Routes } from '../../../../routes-table';
import { FormattedMessage } from 'react-intl';
import { editText, MANAGE_TEXT } from '../../../../constants/common-labels.constants';
import DefaultButton from '../../../global/default-button/default-button';
import classnames from 'classnames';

type EventHubsListItemProps = {
    accountId: number;
    eventHub: IEventHubDTO;
    onDoubleClick: () => void;
    onClickEdit: () => void;
    isSelected: boolean;
    hasEditPermission: boolean;
};

export const EventHubsListItem = observer(({ eventHub, onDoubleClick, accountId, onClickEdit, isSelected, hasEditPermission }: EventHubsListItemProps) => {
    const dateFormatter = Container.get<DateTimeFormatter>(DateTimeFormatter);
    const creationDate = dateFormatter.dateToLocalStringFormat(
        new Date(eventHub.createdAt),
        DateTimeFormatter.localTimeZone,
        dateFormatter.getLocalTimeFormat(),
    );

    const routeParams = {
        accountId: String(accountId),
        eventHubId: String(eventHub.eventHubId),
    };

    const cellEffectClasses = classnames({
        'active': isSelected,
        'hoverable': !isSelected,
    });

    return (
        <tr onDoubleClick={onDoubleClick}>
            <td className={cellEffectClasses}>
                <div className='flex center'>
                    <Text withEllipsis message={eventHub.eventHubName} />
                    {hasEditPermission && (
                        <DefaultButton
                            className='visible-while-hovered'
                            modifier={['slim', 'link']}
                            text={editText()}
                            onClick={onClickEdit}
                        />
                    )}
                </div>
            </td>
            <Text className={cellEffectClasses} withEllipsis message={creationDate} tag='td' />
            <td className={`align-right ${cellEffectClasses}`}>
                <Link routeEnum={Routes.EventHubAttendees} routeParams={routeParams} className='manage-button no-text-decoration'>
                    <span className='default-button default-button--slim visible-while-hovered'>
                        <FormattedMessage {...MANAGE_TEXT} />
                    </span>
                </Link>
            </td>
        </tr>
    );
});